<div class="new-client">
  <div class="client-form">
    <div class="client-form-inner">
      <h3>Run</h3>
      <form [formGroup]="newFolder" class="folder-form">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Select Folder</mat-label>
          <mat-select>
            <mat-option
              *ngFor="let folder of listOfFolders"
              [value]="folder.id"
              (click)="setFolder(folder)"
            >
              {{ folder.name }} ({{ folder.invoices.items.length }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="buttonDiv">
          <button
            mat-button
            class="add-client-button"
            type="button"
            (click)="getZipFile()"
          >
            Run
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="client-form" *ngIf="!isProcessDone">
    <div class="client-form-inner middle" style="position: relative">
      <mat-progress-spinner
        *ngIf="isProgress"
        mode="indeterminate"
      ></mat-progress-spinner>
      <h3>{{ isProgress ? "In progress.." : "Select folder.." }}</h3>
    </div>
  </div>
  <div class="client-form" *ngIf="isProcessDone">
    <div class="client-form-inner">
      <h3>Completed</h3>
      <P
        >Number of invoices in folder:
        {{ this.selectedFolder.invoices.items.length }}</P
      >

      <div class="buttonDiv">
        <button mat-button class="add-client-button" (click)="downloadFile()">
          Export file
        </button>
      </div>
      <div class="buttonDiv">
        <button
          mat-button
          class="add-client-button-2"
          type="submit"
          (click)="close()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
